// extracted by mini-css-extract-plugin
export default {"root":"rV8DH","icon":"_3T4Sj","tooltip":"_1E7IE"};